module.exports = __webpack_public_path__ + "static/media/generate-success-illustration.2865ce19.png";